import React, { useState } from 'react';
import { string } from 'prop-types';
import Drawer from '@mui/material/Drawer';
import { ActionWrapper, ActionWrapperMobile, MenuWrapper, MenuItem, MobileMenuWrapper, DrawerLogoWrapper } from './PublicNav.styles';
import menuLinks from './navigationConfiguration';
import { Logos, Button, Icons } from '../..';
const {
  horizontal: HorizontalLogo
} = Logos;
const {
  menu: Menu,
  incomplete: Incomplete
} = Icons;
export const SmallViewportMenu = _ref => {
  let {
    loginUrl,
    registerUrl
  } = _ref;
  const [isOpen, setIsOpen] = useState(false);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MenuWrapper, null, /*#__PURE__*/React.createElement(Menu, {
    onClick: () => setIsOpen(true),
    className: "menu",
    "data-test-id": "open-menu"
  })), /*#__PURE__*/React.createElement("a", {
    href: "/"
  }, /*#__PURE__*/React.createElement(HorizontalLogo, {
    className: "small-logo"
  })), /*#__PURE__*/React.createElement(ActionWrapper, null, /*#__PURE__*/React.createElement(Button, {
    href: loginUrl,
    size: "small"
  }, "Log In")), /*#__PURE__*/React.createElement(Drawer, {
    fixed: "fixed",
    open: isOpen,
    className: "drawer"
  }, /*#__PURE__*/React.createElement(DrawerLogoWrapper, null, /*#__PURE__*/React.createElement(Incomplete, {
    onClick: () => setIsOpen(false),
    className: "close"
  }), /*#__PURE__*/React.createElement(HorizontalLogo, {
    className: "small-logo"
  }), /*#__PURE__*/React.createElement(Button, {
    href: loginUrl,
    size: "small"
  }, "Log In")), /*#__PURE__*/React.createElement(MobileMenuWrapper, null, /*#__PURE__*/React.createElement("div", null, menuLinks.map(_ref2 => {
    let {
      name,
      href
    } = _ref2;
    return /*#__PURE__*/React.createElement(MenuItem, {
      key: name,
      large: true,
      href: href
    }, name);
  })), /*#__PURE__*/React.createElement(ActionWrapperMobile, null, /*#__PURE__*/React.createElement(Button, {
    href: loginUrl,
    size: "extra-large",
    color: "blue",
    variant: "outlined"
  }, "Log In"), /*#__PURE__*/React.createElement(Button, {
    href: registerUrl,
    variant: "contained",
    size: "extra-large"
  }, "Sign Up")))));
};
SmallViewportMenu.propTypes = {
  loginUrl: string,
  registerUrl: string
};
SmallViewportMenu.defaultProps = {
  loginUrl: '',
  registerUrl: ''
};